//DASHBOARD
export const GET_DASHBOARD_INFO = "GET_DASHBOARD_INFO"
export const GET_DASHBOARD_INFO_SUCCESS = "GET_DASHBOARD_INFO_SUCCESS"
export const GET_DASHBOARD_INFO_FAIL = "GET_DASHBOARD_INFO_FAIL"

export const GET_DASHBOARD_INFO_FILTER = "GET_DASHBOARD_INFO_FILTER"

export const GET_MEDIAN_AVERAGE_INFO = "GET_MEDIAN_AVERAGE_INFO"
export const GET_MEDIAN_AVERAGE_INFO_SUCCESS = "GET_MEDIAN_AVERAGE_INFO_SUCCESS"
export const GET_MEDIAN_AVERAGE_INFO_FAIL = "GET_MEDIAN_AVERAGE_INFO_FAIL"

export const SHOW_LOADING = "SHOW_LOADING"
export const HIDE_LOADING = "HIDE_LOADING"
